import React from 'react'
import Footer from '../components/footer'
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { Link } from 'react-router-dom';
import './footer.css'

export function FooterContainer() {
    return (
        <Footer style={{marginTop: "0px"}}>
            <Footer.Wrapper>
            <Footer.Row>
                <Footer.Column>
                <Footer.Title>About Us</Footer.Title>
                
                    <Footer.Link href="/about#story"><Link to="/about#story" className='footerlinks'>Story</Link></Footer.Link>
                    
                    
                    <Footer.Link href="/about#testimonials"><Link to="/about#testimonials" className='footerlinks'>Testimonials</Link></Footer.Link>
                    
                </Footer.Column>
                <Footer.Column>
                <Footer.Title>Services</Footer.Title>
                    <Footer.Link ><Link to="/marketing" className='footerlinks'>Marketing</Link></Footer.Link>
                    <Footer.Link ><Link to="/consulting" className='footerlinks'>Consulting</Link></Footer.Link>
                    <Footer.Link ><Link to="/development" className='footerlinks'>Development</Link></Footer.Link>
                    <Footer.Link ><Link to="/brokerage" className='footerlinks'>Brokerage</Link></Footer.Link>
                </Footer.Column>
                <Footer.Column>
                <Footer.Title>Contact Us</Footer.Title>
                <div 
                style={{display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                width: '100%',
                marginBottom: '10px'
            }} className="phone1"
                >
                    <div className="phone-icon1">
                    <LocalPhoneIcon style={{color: "white"}} /></div>
                    <div className="phone-link1">
                    <Footer.Link href="tel:+254773722209">+254 104141843</Footer.Link></div> </div>
                    <div
                    style={{display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginBottom: '10px'
                }} className="email1"
                    >
                        <div className='email-icon1'>
                    <EmailIcon style={{color: "white"}} /></div>
                    <div className="email-link1">
                    <Footer.Link href="mailto: info@paragonhomessolutions.com">paragonhomess...</Footer.Link>
                    </div>
                    </div>
                </Footer.Column>
                <Footer.Column>
                <Footer.Title>Social</Footer.Title>
                    <Footer.Link href="https://www.facebook.com/paragonhomessolutions?mibextid=ZbWKwL">Facebook</Footer.Link>
                    <Footer.Link href="https://instagram.com/paragonhomessolutions?igshid=ZDdkNTZiNTM=">Instagram</Footer.Link>
                    <Footer.Link href="https://youtube.com/@paragonhomessolutions">Youtube</Footer.Link>
                    <Footer.Link href="https://twitter.com/paragon_homes?t=Z6rB2FIYaMQJ-DavG6i0iA&s=09">Twitter</Footer.Link>
                    <Footer.Link href="https://www.linkedin.com/company/paragon-homes-solutions/">LinkedIn</Footer.Link>
                </Footer.Column>
            </Footer.Row>
            </Footer.Wrapper>
        </Footer>
    )
}